<template>
  <v-app>
    <Authentication
      :register="'Register'"
      :resetPassword="'¿Forgot?'"
      :cancel="null"
      :success="false"
      :operationField="'appLogin'"
      :transactionField="'loginTran'"
      :registerField="'appRegister'"
      :resetPasswordField="'appResetPassword'"
      :maxWidth="'500'"
      @transaction-process="transactionProcess"
      @close-dialog="closeDialog"
      @init="init"
    />
  </v-app>
</template>

<script>
import jwt_decode from "jwt-decode";
import { environment } from "./../../../environment/environment.js";
import Authentication from "./Authentication";

export default {
  name: "Login",
  props: [],
  data() {
    return {
      environment: environment,
    };
  },
  components: {
    Authentication,
  },
  methods: {
    parseLogin(getData, getResponse) {
      const authentication = this.getTranApiAuthentication(getResponse);
      const customData = this.getTranApiData(getResponse);
      const userName = getData[authentication.userId];

      // Token processing
      const token = this.notBlank(authentication.tokenId)
        ? customData[authentication.tokenId]
        : customData;
      const jwt = this.notBlank(authentication.jwtId)
        ? customData[authentication.jwtId]
        : customData;

      // JWT processing
      const decoded = jwt_decode(jwt);

      const firstName = decoded?.[authentication.firstNameId] ?? '';
      const lastName = decoded?.[authentication.lastNameId] ?? '';
      const roles = decoded?.[authentication.rolesId] ?? [];
      const changePassword = decoded?.[authentication.changePasswordId] ?? false;

      const basic = {
        userName,
        token,
        jwt,
        fullName: firstName + " " + lastName,
        initials: firstName.substring(0, 1) + lastName.substring(0, 1),
        roles,
        changePassword,
      }

      let custom = {};
      authentication?.otherFieldsIds.filter(key => decoded?.[key]).forEach(key => {
        custom[key] = decoded?.[key];
      })

      return { ...basic, ...custom };
    },

    transactionProcess(data) {
      if (data.success == true) {
        const session = {
          details: this.parseLogin(data.data, data.response),
          loggedIn: true,
        };
        if (session.details.changePassword) {
          this.saveSession(session, data.applicationName);
          this.goToChangePassword(
            data.applicationName,
            session.details.userName
          );
        } else {
          this.saveSession(session, data.applicationName);
          if (data.operationApplication) {
            this.goToApplication(data.applicationName);
          } else {
            this.goToMain();
          }
        }
      }
    },

    closeDialog() {},

   init(data) {
     this.clearSession(data.applicationName);
   }
  },
  created() {
  },
};
</script>

<style>
</style>